import React from "react";
import { useSelector } from "react-redux";
import { QRCodeOverlay } from "web/react/components/qrcode-overlay/qrcode-overlay";
import { SoftSignupDialog } from "web/react/components/soft-signup-dialog/soft-signup-dialog";
import { ReduxStoreState } from "web/redux/store";

export function CustomerCaptureOverlay(): JSX.Element | null {
    const {
        open: isOpen,
        captureType,
        blockType,
        analyticsEventCategory,
        analyticsEventLabel,
    } = useSelector((state: ReduxStoreState) => {
        return state.customerCaptureOverlay;
    });

    if (!captureType || !isOpen) {
        return null;
    }

    if (captureType === "qr_code") {
        return <QRCodeOverlay />;
    }

    return (
        <SoftSignupDialog
            analyticsEventCategory={analyticsEventCategory}
            analyticsEventLabel={analyticsEventLabel}
            captureType={captureType}
            blockType={blockType}
            overlayOpen={isOpen}
        />
    );
}
